import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function OdaklanmaTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['odaklanma-testi']} />;
}
